// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ZugewieseneRechnungBaustellenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type GetZugewieseneBaustellenQuery = {
  search?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useGetZugewieseneBaustellen(): (
  rechnungsId: string,
  query: GetZugewieseneBaustellenQuery
) => Promise<ZugewieseneRechnungBaustellenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungsId, query = {}) =>
      (await getAPI()).rechnungen.getZugewieseneBaustellen({
        rechnungsId,
        ...query,
      }),
    [getAPI]
  );
}
